import { render, staticRenderFns } from "./SFunDetails.vue?vue&type=template&id=65ecba10"
import script from "./SFunDetails.vue?vue&type=script&lang=js"
export * from "./SFunDetails.vue?vue&type=script&lang=js"
import style0 from "./SFunDetails.vue?vue&type=style&index=0&id=65ecba10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports